'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _mapValues = require('lodash/mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

var _form = require('../lib/form');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withForm = function withForm(config) {
  return function (ComponentToWrap) {
    return function (_Component) {
      _inherits(_class, _Component);

      function _class(props) {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.updateValues = _this.updateValues.bind(_this);
        _this.resetForm = _this.resetForm.bind(_this);
        _this.submitForm = _this.submitForm.bind(_this);

        var options = _this.initOptions(config);
        var fields = _this.initFields(options.fields);
        _this.state = {
          fields: _this.validateFields(fields),
          options: options
        };
        return _this;
      }

      _createClass(_class, [{
        key: 'initOptions',
        value: function initOptions(config) {
          var defaults = { fields: {} };
          var supplied = typeof config === 'function' ? config(this.props) : config;
          return (0, _merge2.default)(defaults, supplied);
        }
      }, {
        key: 'initialValue',
        value: function initialValue(field) {
          return (0, _form.isBoolean)(field.type) ? false : '';
        }
      }, {
        key: 'initFields',
        value: function initFields(fields) {
          var _this2 = this;

          return (0, _mapValues2.default)(fields, function (field, key) {
            return _extends({}, field, {
              name: key,
              value: field.initial || _this2.initialValue(field),
              onChange: _this2.handleChange(key),
              onBlur: _this2.handleChange(key, true)
            });
          });
        }
      }, {
        key: 'validateFields',
        value: function validateFields(fields) {
          var _this3 = this;

          return (0, _mapValues2.default)(fields, function (field) {
            var validations = _this3.validateField(field.validators, field.value, _this3.getValues(fields));

            return _extends({}, field, {
              validations: validations,
              invalid: !(0, _isEmpty2.default)(validations),
              error: field.touched && !(0, _isEmpty2.default)(validations)
            });
          });
        }
      }, {
        key: 'validateField',
        value: function validateField(validators, value, values) {
          var _this4 = this;

          switch (typeof validators === 'undefined' ? 'undefined' : _typeof(validators)) {
            case 'function':
              return validators(value, values);
            case 'object':
              var validations = validators.map(function (validator) {
                return _this4.validateField(validator, value, values);
              });
              return validations.filter(function (v) {
                return v;
              });
            default:
              return validators;
          }
        }
      }, {
        key: 'checkIfValid',
        value: function checkIfValid(fields) {
          return (0, _filter2.default)(fields, function (filter) {
            return filter.invalid;
          }).length === 0;
        }
      }, {
        key: 'touchFields',
        value: function touchFields(fields) {
          return (0, _mapValues2.default)(fields, function (field) {
            return (0, _merge2.default)({}, field, {
              touched: true,
              error: !(0, _isEmpty2.default)(field.validations)
            });
          });
        }
      }, {
        key: 'handleChange',
        value: function handleChange(key, touched) {
          var _this5 = this;

          return function (value) {
            var field = _this5.state.fields[key];
            var updatedFields = _extends({}, _this5.state.fields, _defineProperty({}, key, _extends({}, field, {
              value: value,
              touched: touched || field.touched,
              dirty: value !== field.initial
            })));

            var fields = _this5.validateFields(updatedFields);

            if (_this5.state.options.onFormChange) {
              _this5.state.options.onFormChange(_this5.getForm(fields));
            }

            _this5.setState({ fields: fields });
          };
        }
      }, {
        key: 'getValues',
        value: function getValues(fields) {
          return (0, _mapValues2.default)(fields, 'value');
        }
      }, {
        key: 'getValidations',
        value: function getValidations(fields) {
          return (0, _mapValues2.default)(fields, 'validations');
        }
      }, {
        key: 'updateValues',
        value: function updateValues(keys) {
          var _this6 = this;

          var newValues = (0, _mapValues2.default)(keys, function (value, key) {
            return _extends({}, _this6.state.fields[key], {
              value: value
            });
          });

          var updatedFields = _extends({}, this.state.fields, newValues);

          this.setState({
            fields: this.validateFields(updatedFields)
          });
        }
      }, {
        key: 'resetForm',
        value: function resetForm() {
          var fields = this.initFields(this.state.options.fields);
          this.setState({
            fields: this.validateFields(fields)
          });
        }
      }, {
        key: 'submitForm',
        value: function submitForm() {
          var _this7 = this;

          var fields = this.touchFields(this.state.fields);
          this.setState({ fields: fields });
          return new Promise(function (resolve, reject) {
            return _this7.checkIfValid(fields) ? resolve(_this7.getValues(fields)) : reject(_this7.getValidations(fields));
          });
        }
      }, {
        key: 'getForm',
        value: function getForm(fields) {
          return {
            fields: fields,
            values: this.getValues(fields),
            invalid: !this.checkIfValid(fields),
            validations: this.getValidations(fields),
            updateValues: this.updateValues,
            resetForm: this.resetForm,
            submit: this.submitForm
          };
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(ComponentToWrap, _extends({}, this.props, {
            form: this.getForm(this.state.fields)
          }));
        }
      }]);

      return _class;
    }(_react.Component);
  };
};

exports.default = withForm;


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/with-form/index.js
// module id = 99
// module chunks = 0